export type GetSortIndex<T> = (element: T) => number | string;

const compareAlphabetically = (left: string, right: string) => left.localeCompare(right, ["no-NO"]);

export const compare = <T>(left: T, right: T, indexFunction?: GetSortIndex<T>) => {
  const leftIndex = indexFunction ? indexFunction(left) : left;
  const rightIndex = indexFunction ? indexFunction(right) : right;

  if (typeof leftIndex == "number" && typeof rightIndex == "number") return leftIndex - rightIndex;

  if (typeof leftIndex == "string" && typeof rightIndex == "string") {
    return compareAlphabetically(leftIndex, rightIndex);
  }

  throw new Error("Sort index function gives inconsistent index types");
};
